export enum VehicleFuelType {
  Gasoline = 'gasoline',
  Diesel = 'diesel',
  Electric = 'electric',
  Hybrid = 'hybrid',
}

export enum VehicleGearbox {
  Manual = 'manual',
  Automatic = 'automatic',
}
